define((require) => {
    "use strict";

    var $                                               = require("jquery"),
        _                                               = require("underscore"),
        CustomJsAction                                  = require("shared/ui/experience/action/customJs/CustomJsAction"),
        CustomJsActionPropertiesView                    = require("ui/experience/action/customJs/CustomJsActionPropertiesView"),
        SalesforceCommerceConnect                       = require("ui/experience/widgets/salesforceCommerceWidget/service/SalesforceCommerceConnect"),
        SalesforceCommerceQuickViewAction               = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewAction"),
        SalesforceCommerceQuickViewActionPropertiesView = require("ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewActionPropertiesView"),
        JsAction                                        = require("shared/ui/experience/action/js/JsAction"),
        JsActionPropertiesView                          = require("ui/experience/action/js/JsActionPropertiesView"),
        LightboxAction                                  = require("shared/ui/experience/action/lightbox/LightboxAction"),
        LightboxActionPropertiesView                    = require("ui/experience/action/lightbox/LightboxActionPropertiesView"),
        LinkAction                                      = require("shared/ui/experience/action/link/LinkAction"),
        LinkActionPropertiesView                        = require("ui/experience/action/link/LinkActionPropertiesView"),
        LoggedInUserState                               = require("shared/ui/user/LoggedInUserState"),
        Preconditions                                   = require("shared/util/Preconditions"),
        ProductActionPropertiesView                     = require("ui/experience/action/product/ProductActionPropertiesView"),
        ProductCustomJsAction                           = require("shared/ui/experience/action/product/ProductCustomJsAction"),
        ProductLightboxAction                           = require("shared/ui/experience/action/product/ProductLightboxAction"),
        ProductLinkAction                               = require("shared/ui/experience/action/product/ProductLinkAction"),
        ProductWidgetModel                              = require("shared/ui/experience/widgets/productWidget/ProductWidgetModel"),
        SceneNavigationAction                           = require("shared/ui/experience/action/sceneNavigation/SceneNavigationAction"),
        SceneNavigationActionPropertiesView             = require("ui/experience/action/sceneNavigation/SceneNavigationActionPropertiesView");

    var STANDARD_ACTION_SELECT_OPTIONS = [
        {label: "Open link", value: {type: LinkAction.TYPE}},
        {label: "Run JavaScript code", value: {type: JsAction.TYPE}},
        {label: "Open lightbox", value: {type: LightboxAction.TYPE}},
        {label: "Navigate scenes", value: {type: SceneNavigationAction.TYPE}}
    ];

    var EMAIL_ACTION_SELECT_OPTIONS = [
        {label: "Open link", value: {type: LinkAction.TYPE}}
    ];

    var actionTypeToPropertiesView = new Map(); // TODO: can this be merged into a descriptor like the WidgetTypes? Or only editor related?

    actionTypeToPropertiesView.set(LinkAction.TYPE, LinkActionPropertiesView);
    actionTypeToPropertiesView.set(JsAction.TYPE, JsActionPropertiesView);
    actionTypeToPropertiesView.set(CustomJsAction.TYPE, CustomJsActionPropertiesView);
    actionTypeToPropertiesView.set(LightboxAction.TYPE, LightboxActionPropertiesView);
    actionTypeToPropertiesView.set(SceneNavigationAction.TYPE, SceneNavigationActionPropertiesView);
    // The properties view for the ProductCustomJsAction is identical to the CustomJsAction, so we
    // re-use the view.
    actionTypeToPropertiesView.set(ProductCustomJsAction.TYPE, CustomJsActionPropertiesView);
    actionTypeToPropertiesView.set(ProductLightboxAction.TYPE, ProductActionPropertiesView);
    actionTypeToPropertiesView.set(ProductLinkAction.TYPE, ProductActionPropertiesView);
    actionTypeToPropertiesView.set(SalesforceCommerceQuickViewAction.TYPE, SalesforceCommerceQuickViewActionPropertiesView);

    var ActionHelper = {
        /**
         * Enhances and formats the Action Drop-down with additional metadata (e.g - icons).
         *
         * @param {Object} state Select2 object containing information about the current option.
         * @returns {String|Object} Either a JQuery object or a normal String
         */
        getFormattedOption: function(state) {
            if (state.id && state.id === SalesforceCommerceQuickViewAction.TYPE) {
                return $("<span>", {
                    "class": "action",
                    html: [state.text, $("<img>", {
                        id: "salesforce-commerce-logo",
                        src: "images/integration/addons/salesforce-commerce/small_icon.png"
                    })]
                });
            }

            return state.text;
        },

        /**
         * Returns the list of available actions formatted for the actions drop down menu. Includes
         * custom JS, SalesforceCommerce and product widget actions, and takes hidden and disabled widgets
         * into account.
         *
         * @param {Boolean} onlyShowProductActions Only show the product actions.
         * @returns {Object} List of actions formatted for a drop down control.
         */
        getActionSelectOptionCollection: function(onlyShowProductActions, isEmailModeEnabled) {
            var ownedPrototypeActions = this._getOwnedPrototypeActions();
            var ACTIVE_ACTION_SELECT_OPTIONS =
                isEmailModeEnabled
                    ? EMAIL_ACTION_SELECT_OPTIONS
                    : STANDARD_ACTION_SELECT_OPTIONS;

            // If we only have to show product actions, return here without grouping them.
            if (onlyShowProductActions) {
                return ownedPrototypeActions.productPrototypeActions.map(this._toSelectOptionJson);
            }

            // If we don't have any extra actions, just return the standard actions without
            // grouping them.
            if (!SalesforceCommerceConnect.isQuickViewEnabled() &&
                ownedPrototypeActions.customJsPrototypeActions.length === 0 &&
                ownedPrototypeActions.productPrototypeActions.length === 0) {
                return ACTIVE_ACTION_SELECT_OPTIONS;
            }

            var selectOptionCollection = {
                "opt_labels": []
            };

            // Add the standard options as a group.
            this._addToSelectOptionCollection(selectOptionCollection, "Standard", ACTIVE_ACTION_SELECT_OPTIONS);

            // Add SalesforceCommerce to select options.
            if (!isEmailModeEnabled) {
                if (SalesforceCommerceConnect.isQuickViewEnabled()) {
                    var salesforceCommerceSelectOptions = [{
                        label: "SFCC QuickView",
                        value: {
                            type: SalesforceCommerceQuickViewAction.TYPE
                        }
                    }];

                    this._addToSelectOptionCollection(selectOptionCollection, "Add-ons", salesforceCommerceSelectOptions);
                }

                this._addToSelectOptionCollection(
                    selectOptionCollection, "Custom Actions",
                    ownedPrototypeActions.customJsPrototypeActions.map(this._toSelectOptionJson)
                );
                this._addToSelectOptionCollection(
                    selectOptionCollection, "Product Actions",
                    ownedPrototypeActions.productPrototypeActions.map(this._toSelectOptionJson)
                );
            }

            return selectOptionCollection;
        },

        /**
         * Returns the prototype action owned by the current company, split into custom JavaScript
         * prototype actions and product prototype actions.
         */
        _getOwnedPrototypeActions: function() {
            var customJsPrototypeActions = LoggedInUserState.get("prototypeActionCollection").filter((prototypeAction) => {
                return (prototypeAction.get("action").get("type") === CustomJsAction.TYPE);
            });

            var productPrototypeActions = LoggedInUserState.get("prototypeActionCollection").filter((prototypeAction) => {
                return this._isVisibleProductWidget(prototypeAction.get("action").get("widgetId"));
            });

            return {
                customJsPrototypeActions: customJsPrototypeActions,
                productPrototypeActions: productPrototypeActions
            };
        },

        /**
         * Checks if the widget is a visible product widget.
         *
         * @param {String} prototypeWidgetId The ID of the widget to be verified.
         * @returns {Boolean}
         * @throws {Error} If more than one matching widget is found.
         */
        _isVisibleProductWidget: function(prototypeWidgetId) {
            if (!_.isString(prototypeWidgetId)) {
                return false;
            }

            // Only owned widgets are product widgets.
            var matchingPrototypeWidgets = LoggedInUserState.get("prototypeWidgetCollection")
                .filter((prototypeWidget) => {
                    return prototypeWidget.get("id") === prototypeWidgetId;
                });

            if (matchingPrototypeWidgets.length !== 1) {
                Preconditions.fail("Expected exactly one matching widget. Found " + matchingPrototypeWidgets.length + " matches.");
                return false;
            }

            var widget = matchingPrototypeWidgets[0].get("widget");

            if (!widget.get("visible")) {
                return false;
            }

            if (widget.get("type") !== ProductWidgetModel.TYPE) {
                return false;
            }

            return true;
        },

        /**
         * Returns the action as a JSON object for a Stickit drop down menu.
         */
        _toSelectOptionJson: function(prototypeAction) {
            var selectOptionJson = {
                label: prototypeAction.get("action").get("name"),
                value: {
                    type: prototypeAction.get("action").get("type"),
                    actionId: prototypeAction.get("id")
                }
            };

            return selectOptionJson;
        },

        /**
         * Add the group to the select option collection and add the select options to that group.
         *
         * @param {Object} collection The collection of select options to add to.
         * @param {String} groupLabel The label for the group header.
         * @param {Object} selectOptions Array of select options to add.
         */
        _addToSelectOptionCollection: function(collection, groupLabel, selectOptions) {
            if (selectOptions.length >= 1) {
                collection.opt_labels.push(groupLabel);
                collection[groupLabel] = selectOptions;
            }
        },

        /**
         * Returns the options for the given action. For normal actions this is just null, but for
         * owned  actions, information like parameter names are extracted from the settings.
         */
        getActionOptions: function(actionIdentifier) {
            // If the action doesn't have an actionId, it is not owned, and we don't have to look
            // any further to dig out the options.
            if (!_.isString(actionIdentifier.actionId)) {
                // Almost sure this is always null. (JAG)
                return actionIdentifier.options;
            }

            var prototypeAction = LoggedInUserState.get("prototypeActionCollection").findWhere({"id": actionIdentifier.actionId});

            var options = {
                actionId: prototypeAction.get("id"),
                actionVersion: prototypeAction.get("version"),
                name: prototypeAction.get("action").get("name"),
                // Cloning the parameters because we don't want to mess with the default values.
                parameters: _.clone(prototypeAction.get("action").get("parameters"))
            };

            var actionType = prototypeAction.get("action").get("type");

            switch (actionType) {
                case CustomJsAction.TYPE:
                    options.code = prototypeAction.get("action").get("code");
                    break;

                case ProductCustomJsAction.TYPE:
                    options.code = prototypeAction.get("action").get("code");
                    break;

                case ProductLightboxAction.TYPE:
                    options.height = prototypeAction.get("action").get("height");
                    options.urlTemplate = prototypeAction.get("action").get("urlTemplate");
                    options.width = prototypeAction.get("action").get("width");
                    break;

                case ProductLinkAction.TYPE:
                    options.target = prototypeAction.get("action").get("target");
                    options.urlTemplate = prototypeAction.get("action").get("urlTemplate");
                    break;

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Action type passed '" + actionType + "' not recognized.");
                    break;
            }

            return options;
        },

        /**
         * Checks if the specified action type is enabled for the current company. Currently it's
         * only SalesforceCommerce actions that can be disabled.
         *
         * @param {String} type The type of the action, e.g. "LinkAction".
         * @returns {boolean}
         */
        isActionEnabledForCompany: function(type) {
            if (type === SalesforceCommerceQuickViewAction.TYPE) {
                return SalesforceCommerceConnect.isQuickViewEnabled();
            }

            return true;
        },

        // Global Action Properties View Map.
        actionTypeToPropertiesViewMap: actionTypeToPropertiesView,

        convertStringToHtml(text) {
            const htmlText = text.trim();
            const template = document.createElement("template");
            template.innerHTML = htmlText;
            return template.content.firstChild;
        }
    };

    return ActionHelper;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/ActionHelper.js